<template>
  <section class="app-main" :style="{ 'min-height': isIframe ? '100%' : '' }">
    <transition name="fade-transform" mode="out-in">
      <div v-show="!$route.meta.noCache">
        <keep-alive :include="cachedViews">
          <router-view :key="key" v-if="!$route.meta.noCache" />
        </keep-alive>
      </div>
    </transition>
    <transition name="fade-transform" mode="out-in">
      <router-view v-if="$route.meta.noCache"></router-view>
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  data() {
    return {
      isIframe: self != top,
    };
  },
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews;
    },
    key() {
      return this.$route.path;
    },
  },
};
</script>

<style lang="scss" scoped>
.app-main {
  /* 50= navbar  50  */
  min-height: calc(100vh - 50px);
  width: 100%;
  position: relative;
}

.fixed-header + .app-main {
  padding-top: 50px;
}

.hasTagsView {
  .app-main {
    /* 84 = navbar + tags-view = 50 + 34 */
    min-height: calc(100vh - 84px);
    background: #fff;
    border-radius: 8px;
  }

  .fixed-header + .app-main {
    padding-top: 84px;
  }
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}
</style>
